import * as COMMON_CONFIG from '@flyblack/common/config';

export const { API, ENVIRONMENT, SENTRY_DSN, RELEASE } = COMMON_CONFIG;

declare var CONFIG: {
  CLIENT_ID: string;
};

export const { CLIENT_ID } = CONFIG;
